module.exports = __webpack_public_path__ + "img/sb3.b4d2516e.jpg";